module.exports = __webpack_public_path__ + "media/images/icons/phone-5d96a9ac192812c226db4a9fb4daa362.svg";